import { Injectable } from "@angular/core";
import * as Stomp from 'stompjs';
import { SOCKET_URL } from './chat-constants';

@Injectable()
export class WebSocketService {
    
    constructor() {}
    
    connect() {
        let socket = new WebSocket(SOCKET_URL);
        let stompClient = Stomp.over(socket);
        return stompClient;
    }
}